"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Contravariant = exports.contramap = exports.URI = void 0;
const function_1 = require("fp-ts/function");
exports.URI = "Show";
const contramap = (f) => (m) => ({ show: (0, function_1.flow)(f, m.show) });
exports.contramap = contramap;
exports.Contravariant = {
    URI: exports.URI,
    contramap: (m, f) => (0, function_1.pipe)(m, (0, exports.contramap)(f)),
};
